module.exports = __webpack_public_path__ + "static/media/youtube.07aae70d.svg";